import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useBranding } from "@/contexts/BrandingContext";

const PendingApprovalPage = () => {
  const { signOut, profile } = useAuth();
  const { fullLogo } = useBranding();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="max-w-md text-center">
        <img src={fullLogo} alt="Value Gift Vouchers" className="h-44 mx-auto mb-8 object-contain" />
        <div className="w-16 h-16 rounded-full bg-brand-gold-lt flex items-center justify-center mx-auto mb-4">
          <Clock className="w-8 h-8 text-brand-gold" />
        </div>
        <h1 className="text-2xl font-bold text-foreground mb-2">Account Under Review</h1>
        <p className="text-muted-foreground mb-2">
          Your {profile?.role?.replace("_", " ")} account is being reviewed by our team.
        </p>
        <p className="text-sm text-muted-foreground mb-8">
          You'll receive an email once your account is approved. This usually takes 1–2 business days.
        </p>
        <Button
          onClick={signOut}
          className="bg-brand-forest hover:bg-brand-green-dk text-white"
        >
          Sign Out
        </Button>
      </div>
    </div>
  );
};

export default PendingApprovalPage;
